import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  destinyID: null,
  removePacketID: null,
  departureType: null,
  search: '',
  loaded: true,
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
};

const packageDepartureSlice = createSlice({
  name: 'packageDeparture',
  initialState,
  reducers: {
    removePacket: (state, action) => {
      state.removePacketID = action.payload;
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateDestiny: (state, action) => {
      state.destinyID = action.payload;
    },
    updateDepartureType: (state, action) => {
      state.departureType = action.payload;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    resetRemovePacketID: (state) => {
      state.removePacketID = initialState.removePacketID;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = packageDepartureSlice;
